import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewProjectService {
  projectdetails: any = {};
  constructor() { }
}
